/*!
 * This file is part of the TYPO3 CMS-based extension "memorial".
 * (c) Earlybird GmbH <typo3@earlybird.at>
 */
import Map from './map';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('[id][data-map-src]').forEach(function(e) {
    new Map(e);
  });
});
